import React from 'react';
import { connect } from 'react-redux';
import Logger, {LOG_LEVELS} from '../../../utils/logger';
import ListingLines from './ListingLines';
import EditableLocaListingLines from './EditableLocalListingLines';
import EditableReverseChargeLisitingLines from './EditableReverseChargeLisitingLines';
import AddListingLines from './AddListingLines';
import AddLocalListingLines from './AddLocalListingLines';
import LANGUAGES_CONTROLLER from '../../../controllers/languages';
import {FilingTypeEnum} from '../../../utils/enums';

const log = new Logger('REPORTING_OPTION_LISTING_LINES', LOG_LEVELS.DEBUG);

const showAddLinesForm = false;       // Workaround for SVR-4015 to stop the add lines form from being shown for ECL and LL

class ReportingOptionListingLines extends React.Component {

    constructor(props) {
        super(props);
        this.onAdd = this.onAdd.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onModify = this.onModify.bind(this);
        this.onListingTypeChange = this.onListingTypeChange.bind(this);
        this.state = {
            isSales: true
        };
    }

    onDelete(row, original, index, isSales, ecType, filingTypeId) {
        this.props.onDelete(row, original, index, isSales, ecType, filingTypeId);
    }

    onModify(modifiedData, index, ecType)  {
        // Handle sales & callOfStocks data modification
        this.props.onModify(modifiedData, index, ecType);
    }

    onAdd(newLine) {
        this.props.onAdd(Object.assign(newLine, {listingType: this.state.isSales ? 0 : 1}, this.state.isSales), this.state.isSales, this.props.filingTypeId);
    }

    onListingTypeChange(isSales) {
        this.setState({
            isSales: isSales
        });
    }

    getECTypes(){
        let ectypes = (Array.isArray(this.props.data) && this.props.data.length > 0 && this.props.data[0] && this.props.data[0].ECTypes) || [];
        return [...ectypes];
    }
    renderListingView(){
        switch(this.props.filingTypeId) {
            case FilingTypeEnum.ECLISTING:
              return <ListingLines
                    salesData={this.props.salesData} 
                    purchaseData={this.props.purchaseData}
                    callOfStocksData = {this.props.callOfStocksData}
                    onDelete={this.onDelete} 
                    onECTypeChange={this.props.onECTypeChange}
                    onListingTypeChange={this.onListingTypeChange}
                    filingTypeId={this.props.filingTypeId}
                    onModifySales={this.onModify}
                    onModifyCallOfStocks={this.onModify}
                    countryCode={this.props.countryCode}
                    onVATImport={this.props.onVATImport}
                />;
              
            case FilingTypeEnum.LOCALLISTING:
                return <EditableLocaListingLines
                    onDelete={this.onDelete}
                    localListingData={this.props.listingLinesData}
                    filingTypeId={this.props.filingTypeId}
                    countryCode={this.props.countryCode}
                    onVATImport={this.props.onLocalListingVATImport}
                />;
            case FilingTypeEnum.REVERSECHARGELISTING:
                return <EditableReverseChargeLisitingLines
                    onDelete={this.onDelete}
                    reverseChargeListingData = {this.props.listingLinesData}
                    filingTypeId={this.props.filingTypeId}
                />;
            default:
                break;
          }

    }

    render() {
        return (
            <div>
                { this.props.title ? (<h2 className="mt15">{this.props.title}</h2>) : ''}
                {this.renderListingView()}
                { showAddLinesForm ? (
                    this.props.filingTypeId === FilingTypeEnum.ECLISTING ?
                    <AddListingLines
                        title={this.state.isSales ? LANGUAGES_CONTROLLER.format(this.props.languages, 'reportingOptionListingLines_AddNewSales') : LANGUAGES_CONTROLLER.format(this.props.languages, 'reportingOptionListingLines_AddNewAcquisitions')}
                        onAdd={this.onAdd}
                        ecTypes={this.props.ectypeOptions}/>
                    :
                    <AddLocalListingLines
                        title={LANGUAGES_CONTROLLER.format(this.props.languages, 'localListingLines_Title')}
                        onAdd={this.onAdd}
                    />
                    ) : (<div></div>)
                }
            </div>
        );
    }
}


ReportingOptionListingLines.defaultProps = {
    salesData: [],
    purchaseData: [],
    listingLinesData : [],
    onDelete: () => {},
    onModify: () => {},
    onAdd: () => {},
    onECTypeChange: () => {},
    ectypeOptions: [],
    countryCode: '',
    onVATImport: () => {},
    onLocalListingVATImport: () => {}
};

function mapStateToProps(state) {
    log.debug('mapStateToProps: ', state);  
    return {
        languages: state.languages
    };
}

export default connect(mapStateToProps)(ReportingOptionListingLines);
